
<div class="page legacy-page overlayed" id="process-def-new-page">
    <div class="action-bar dark-bg">
        <div class="title no-margin">Crea un nuevo Proceso</div>
        <div class="actions-set">
            <div class="actions-set">
                <a class="action-btn done SaveBtn" href="#"></a>
                |
                <a class="action-btn delete" href="#"></a>
                <a class="action-btn sos" href="#">SOS</a>
            </div>
        </div>
    </div>
    <div class="page-overlay"></div>
    <div class="content">
        <div class="container legacy-container">

            <div class="section" id="nuevo-proceso">
                <form class="legacy-form" id="new-process-def-form">

                    <a class="action-btn CancelBtn" 
                        icon="cancel" 
                        href="#"></a>
                    
                    <h2>Nuevo proceso</h2>
                    <ul>
                        
                        <li class="StringCtrl required" property="title">
                            <label>Nombre</label>
                            <input type="text" size=32 placeholder="" v-model="obj.title"/>
                            <p class="hint">
                                Ingresa aquí un nombre para este nuevo <b>Proceso</b>. 
                                Este campo es necesario.
                            </p>
                        </li>
                        
                        <li class="SelectCtrl required" property="master_def_id">
                            <label>Formulario</label>
                            <select></select>
                            <p class="hint">
                                Elige el Formulario asociado a este proceso.
                                Este campo es necesario.
                            </p>
                        </li>

                        <li class="StringCtrl" property="alias">
                            <label>Alias</label>
                            <input type="text" size=22 v-model="obj.alias"/>
                            <p class="hint">
                                Se usará este alias para referirse al formulario.
                            </p>
                        </li>
        
                        <li class="TextCtrl" property="descr">
                            <label>Descripción</label>
                            <textarea rows="1" v-model="obj.descr"></textarea>
                            <p class="hint">Breve descripción del proceso.</p>
                        </li>
                    </ul>

                    <p class="form-buttons">
                        <button class="CreateBtn" 
                            icon="accept">
                            AGREGAR AHORA
                            </button>
                    </p>

                </form>
            </div> <!-- nuevo-formulario -->

        </div>
    </div>
</div>

<script>
import { onMount } from 'svelte'

onMount(() => {
  window.$("#process-def-new-page").ProcessDefNewPage("#nuevo-proceso");
  console.log("DONE: installed ProcessDefNewPage to hash '#nuevo-proceso'")
})
</script>
